import type { Action } from 'vuex';
import api from '../../api';
import type { ZeusFederatedState } from './mutations';

const getAllFederatedOrganisations: Action<ZeusFederatedState, any> = async ({ commit }) => {
  const res = await api.getAllFederatedOrgs();
  commit('SET_FEDERATED_ORGS', res.data);
};

const createFederatedOrganisation: Action<ZeusFederatedState, any> = async ({ commit }, data) => {
  const res = await api.createFederatedOrg(data);
  commit('ADD_FEDERATED_ORG', res.data);
  return res;
};

const clearFederatedOrgsStore: Action<ZeusFederatedState, any> = ({ commit }) => {
  commit('CLEAR_STATE');
};

export const actions = {
  getAllFederatedOrganisations,
  createFederatedOrganisation,
  clearFederatedOrgsStore,
};
